export default __webpack_public_path__ + "static/media/be-sure-stepsliide3.6cf1dc3e.png";